/**
 * Product URL helpers
 * All products live under /products/:id
 */

/** Category labels for display */
export const categoryLabels: Record<string, string> = {
  ionizers: "Water Ionizers",
  "ro-systems": "RO Systems",
  hydrogen: "Hydrogen Products",
  filters: "Water Filters",
  "ro-filters": "RO Filters & Spares",
  "perfect-water": "Perfect Water Systems",
};

/** Get the product URL — always /products/:id */
export function getProductUrl(productId: string, _category?: string): string {
  return `/products/${productId}`;
}

/** Get the category filter URL on /products page */
export function getCategoryUrl(category: string): string {
  return `/products?category=${category}`;
}
